import React, { Component, createRef } from 'react';
import {
  Button,
  FormGroup,
  Col,
  Container,
  Row
} from 'reactstrap';
import ApiCall from '../../../services/ApiCall'
import { showSwalLoading } from '../../../services/Helper'
import swal from 'sweetalert2'
import jwt from 'jsonwebtoken'
import './Login.css'
import OtpInput from 'react-otp-input'

class VerifyOtp extends Component {

  constructor() {
    super()
    this.reRef = createRef()
  }

  state = {
    otp: '',
    loading: true
  }

  style = {
    backgroundImage: 'linear-gradient(#9675ce,#9675ce),linear-gradient(rgba(120,130,140,.13),rgba(120,130,140,.13))',
    border: 0,
    borderRadius: 0,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    backgroundPosition: 'center bottom,center calc(99%)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '0 2px,100% 1px',
    padding: 0
  }

  componentWillMount() {
    let token = localStorage.getItem('token')
    if (token != null) {
      let userData = jwt.decode(token)
      if (userData) {
        let user = userData.user
        if (user) {
          window.location = '/astra/#/home'
        }
      }
    }
  }

  componentDidMount() {
    this.setState({ loading: false })
  }

  async verifyOtp(e) {
    e.preventDefault()

    showSwalLoading()
    try {
      let { otp } = this.state
      const email = localStorage.getItem('email')
      const res = await ApiCall.verifyOtp({ otp, email })
      swal.close()
      let token = res.data.token
      localStorage.setItem('token', token)
      localStorage.removeItem('email')
      let dataUser = jwt.decode(token)
      let user = dataUser.user
      if (user) {
        window.location.reload()
      }
    } catch (error) {
      swal.close()
      if (error.response) {
        swal('Oops...', error.response.data.message, 'error').then((result) => {
          let { username } = this.state
          window.location.reload().then((result) => {
            this.setState({ username })
          })
        })
      } else {
        swal('Oops...', 'Something went wrong! Check internet connection!', 'error').then((result) => {
          window.location.reload()
        })
        console.error('error message: ', error)
      }
    }
  }


  render() {
    let { otp, loading } = this.state
    if (loading) return (<div></div>)
    return (
      <div className="app flex-row align-items-center background-home">
        <Container>
          <div className="card-form-login">

            <div className='text-center logo'>
              G R E E N
              <img src={'/assets/img/brand/logo-agc.png'} className="" alt="logo astra green company" />
              C O M P A N Y
            </div>

            <p className="text-uppercase text-semibold m-b-15">Verify OTP</p>

            <form onSubmit={this.verifyOtp.bind(this)}>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <OtpInput
                      containerStyle={{
                        display: 'flex',
                        justifyContent: 'space-evenly',
                        marginTop: 24,
                      }}
                      value={otp}
                      onChange={e => { this.setState({ otp: e }) }}
                      numInputs={4}
                      renderInput={(props) => (
                        <input
                          {...props}
                          style={{
                            width: 44,
                            height: 44,
                            border: '1px solid rgba(208, 218, 221, 1)',
                            textAlign: 'center',
                          }}
                        />
                      )}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="12">
                  <Button className="btn btn-success btn-lg btn-loading btn-block text-uppercase waves-effect waves-light" type="submit">VERIFY</Button>
                </Col>
              </Row>
            </form>

          </div>
        </Container>
      </div>
    );
  }
}

export default VerifyOtp;
